/* assets/quantity-gifts.js — v7.3 ANALYTICS FIX ONLY */
(function () {
  const SELECT = {
    radios: [
      '.quantity-breaks input[type="radio"][name*="quantity"]',
      'input[type="radio"][name="quantity"]',
      '.quantity-break input[type="radio"]',
    ].join(','),
    number: '.quantity__input[name="quantity"], input[type="number"][name="quantity"]',
    labels: [
      '.quantity-break[data-quantity]',
      '[data-quantity-break]',
      'label[data-quantity]',
    ].join(',')
  };

  function parseIntSafe(v) {
    const n = parseInt(String(v), 10);
    return isNaN(n) ? null : n;
  }

  class QuantityGifts extends HTMLElement {
    connectedCallback() {
      window.__QG_LOADED = 'v7.3_ANALYTICS_FIX';
      this.updateUnlocked = this.updateUnlocked.bind(this);
      this.rebind = this.rebind.bind(this);
      this.onGiftClick = this.onGiftClick.bind(this);
      this.syncGiftsWithCart = this.syncGiftsWithCart.bind(this);

      this.form = this.closest('form') ||
                  this.closest('.product-form')?.querySelector('form') ||
                  document.querySelector('.product-form form') ||
                  document.querySelector('form[action*="/cart"]') ||
                  document;

      this.rebind();

      this.querySelectorAll('.quantity-gift').forEach(tile => {
        tile.setAttribute('tabindex', '0');
        tile.addEventListener('click', e => this.onGiftClick(e, tile));
        tile.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onGiftClick(e, tile); }
        });
      });

      this.updateUnlocked();
      setTimeout(() => this.updateUnlocked(), 500);
      
      document.addEventListener('cart:refresh', this.syncGiftsWithCart);
    }

    disconnectedCallback() {
      this.detach?.();
      document.removeEventListener('cart:refresh', this.syncGiftsWithCart);
    }

    rebind() {
      this.detach?.();

      const searchRoot = this.form === document ? document : this.form;
      
      this.number = searchRoot.querySelector(SELECT.number) || document.querySelector(SELECT.number) || null;
      this.radios = Array.from(searchRoot.querySelectorAll(SELECT.radios));
      if (this.radios.length === 0) {
        this.radios = Array.from(document.querySelectorAll(SELECT.radios));
      }
      this.labels = Array.from(searchRoot.querySelectorAll(SELECT.labels));
      if (this.labels.length === 0) {
        this.labels = Array.from(document.querySelectorAll(SELECT.labels));
      }

      const unsubs = [];
      const h = () => this.updateUnlocked();

      if (this.number) {
        this.number.addEventListener('input', h);
        this.number.addEventListener('change', h);
        unsubs.push(() => { this.number.removeEventListener('input', h); this.number.removeEventListener('change', h); });
      }
      
      this.radios.forEach(r => r.addEventListener('change', h));
      unsubs.push(() => this.radios.forEach(r => r.removeEventListener('change', h)));
      
      this.labels.forEach(l => l.addEventListener('click', () => setTimeout(h, 150))); 
      unsubs.push(() => this.labels.forEach(l => l.removeEventListener('click', h)));

      this.detach = () => unsubs.forEach(fn => fn());
      this.updateUnlocked();
    }

    getQty() {
      let v = 0;

      const directChecked = document.querySelector('input[type="radio"][name="quantity"]:checked');
      if (directChecked) {
        v = parseIntSafe(directChecked.value);
        if (v) return v;
      }
      
      const labelSel = [
        '.quantity-break[aria-selected="true"]',
        '.quantity-break.active',
        '.quantity-break.is-selected',
        '.quantity-break.selected',
        '[data-quantity].active',
        '[data-quantity].is-selected',
        '[data-quantity][aria-checked="true"]'
      ].join(',');
      
      const activeLabel = this.form.querySelector(labelSel) || document.querySelector(labelSel);
      v = parseIntSafe(activeLabel?.getAttribute('data-quantity'));
      if (v) return v;
      
      v = parseIntSafe(this.number?.value);
      if (v) return v;
      
      return 1;
    }

    updateUnlocked() {
      const qty = this.getQty();
      this.querySelectorAll('.quantity-gift').forEach(tile => {
        const need = parseIntSafe(tile.dataset.quantity) || 1;
        const unlocked = qty >= need;
        tile.dataset.unlocked = unlocked ? 'true' : 'false';
        tile.classList.toggle('quantity-gift--unlocked', unlocked);
      });
      
      this.syncGiftsWithCart();
    }

    async syncGiftsWithCart() {
      // MODIFICATION: Disabling the logic that automatically adds/removes gifts.
      const autoAddGifts = []; // Original was: Array.from(this.querySelectorAll('.quantity-gift[data-auto-add="true"]'));
      if (autoAddGifts.length === 0) return; // Function will exit here, preventing silent cart updates.
      
      if (this.syncing === true) return;
      this.syncing = true;

      try {
        const cartRes = await fetch('/cart.js');
        if (!cartRes.ok) throw new Error('Could not fetch cart');
        const cart = await cartRes.json();

        const updates = {};
        const tilesToUpdateUI = [];

        autoAddGifts.forEach(tile => {
          const unlocked = tile.dataset.unlocked === 'true';
          const giftVariantId = parseIntSafe(tile.dataset.product);
          
          if (!giftVariantId) return;

          const cartItem = cart.items.find(item => item.variant_id === giftVariantId);
          
          if (unlocked) {
            if (!cartItem) {
              updates[giftVariantId] = 1; 
              tile.dataset.adding = 'true';
            } else {
              tilesToUpdateUI.push({ tile, added: true });
            }
          } else {
            if (cartItem) {
              updates[giftVariantId] = 0; 
              tile.dataset.removing = 'true';
              tilesToUpdateUI.push({ tile, added: false });
            } else {
              tilesToUpdateUI.push({ tile, added: false });
            }
          }
        });

        const giftsToModify = Object.keys(updates).length > 0;

        if (giftsToModify) {
          const cartData = { updates: updates };
          
          // ANALYTICS FIX: Mark this request as silent
          window.__GIFT_SYNC_IN_PROGRESS = true;
          
          const updateRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData)
          });

          // Clear the flag after a short delay
          setTimeout(() => { window.__GIFT_SYNC_IN_PROGRESS = false; }, 200);

          if (updateRes.ok) {
            tilesToUpdateUI.forEach(({ tile, added }) => {
              tile.dataset.added = added ? 'true' : 'false';
              
              if (tile.dataset.autoAdd !== 'true') {
                tile.style.opacity = added ? '0.6' : '1';
                tile.style.pointerEvents = added ? 'none' : 'auto';
              }
            });

            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
              console.error('[QuantityGifts] Cart Sync failed:', await updateRes.json());
          }
        } else {
            tilesToUpdateUI.forEach(({ tile, added }) => {
              tile.dataset.added = added ? 'true' : 'false';

              if (tile.dataset.autoAdd !== 'true') {
                tile.style.opacity = added ? '0.6' : '1';
                tile.style.pointerEvents = added ? 'none' : 'auto';
              }
            });
        }
      } catch (err) {
        console.error('[QuantityGifts] Error during cart sync', err);
      } finally {
        this.syncing = false;
        this.querySelectorAll('.quantity-gift[data-auto-add="true"]').forEach(tile => {
          tile.dataset.adding = 'false';
          tile.dataset.removing = 'false';
        });
      }
    }

    async onGiftClick(e, tile) {
      if (tile.dataset.unlocked !== 'true') return;
      if (tile.dataset.adding === 'true') return;
      if (tile.dataset.added === 'true') return;
      if (tile.dataset.autoAdd === 'true') return;

      const id = parseIntSafe(tile.dataset.product);
      if (!id) return;

      tile.dataset.adding = 'true';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1, properties: { _gift: 'Quantity Gift' } }] })
        });
        if (!res.ok) throw new Error('Add failed');
        
        this.syncGiftsWithCart(); 
        
      } catch (err) {
        console.error('[QuantityGifts] manual add error', err);
        tile.dataset.added = 'false';
      } finally {
        tile.dataset.adding = 'false';
      }
    }
  }

  if (!customElements.get('quantity-gifts')) {
    customElements.define('quantity-gifts', QuantityGifts);
  }

  // ====== ANALYTICS SUPPRESSION: Block tracking for gift auto-add/remove ======
  (function blockGiftAnalytics() {
    // Intercept Shopify Web Pixels
    if (window.Shopify?.analytics?.publish) {
      const originalPublish = window.Shopify.analytics.publish;
      window.Shopify.analytics.publish = function(eventName, data) {
        // Block analytics if gift sync is in progress
        if (window.__GIFT_SYNC_IN_PROGRESS) {
          console.log('[QuantityGifts] Blocked analytics event:', eventName);
          return;
        }
        return originalPublish.apply(this, arguments);
      };
    }

    // Intercept cart update fetch calls to suppress pixel firing
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [url, options] = args;
      
      // Detect /cart/update.js calls during gift sync
      if (typeof url === 'string' && url.includes('/cart/update.js') && window.__GIFT_SYNC_IN_PROGRESS) {
        console.log('[QuantityGifts] Silent cart update - suppressing analytics');
        
        // Temporarily block analytics
        const originalPublish = window.Shopify?.analytics?.publish;
        if (originalPublish) {
          window.Shopify.analytics.publish = () => {};
        }
        
        return originalFetch.apply(this, args).then(response => {
          // Restore analytics after request
          setTimeout(() => {
            if (originalPublish) {
              window.Shopify.analytics.publish = originalPublish;
            }
          }, 300);
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };
  })();
})();